import accessAuth from "./AuthControl"
import accessDashboard from "./DashboardControl";

const RoutesMap = {
    ...accessAuth,
    ...accessDashboard,
}

export default RoutesMap;